import { CRITICAL as CRITICAL_COLOR } from "../color/settings";

const ALL_MODES = ["absolute", "percent"] as const;

type Mode = (typeof ALL_MODES)[number];

interface Step {
	color?: string;
	value?: number;
}

const DEFAULT_STEP = {
	color: CRITICAL_COLOR,
	value: 0,
} satisfies Step;

export type { Mode, Step };
export { ALL_MODES, DEFAULT_STEP };
